<template>
  <v-card class="pa-4">
    <div class="font-weight-medium">
      {{ item.id_name }}
    </div>
    <div class="font-weight-bold">
      R code: {{ item.archive_id }}
    </div>
    <div>
      Supplier: {{ item.supplier_name }}
    </div>
    <div>
      Batch: {{ item.batch_number }}
    </div>
    <div>
      Expiry: {{ humanDate }}
    </div>
    <div>
      Internal code: {{ item.internal_code }}
    </div>
    <div>
      Approved by:
    </div>
    <div>
      Opened:
    </div>
  </v-card>
</template>

<script>
export default {
  props: ['item'],
  computed: {
    humanDate () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('ddd D, MMM YYYY')
      }
      return ''
    }
  }
}
</script>
